export const CONTROLLER_URL = "https://gsrh-api.espedata.fr/"; 
export const API_URL = "https://gsrh-api.espedata.fr/api/";

// export const CONTROLLER_URL = "http://localhost:8000/"; 
// export const API_URL = "http://localhost:8000/api/";

// export const CONTROLLER_URL = "https://gsrh-api-testing.espedata.fr/"; 
// export const API_URL = "https://gsrh-api-testing.espedata.fr/api/";

/* DROP CONTROLLER */
export const UPLOADFILE = API_URL + "upload";
export const DISPLAYFILE = API_URL + "displayFile";
export const FILEDELETE = API_URL + "filedelete";
export const DELETEALLFILES = API_URL + "deleteAllFiles";
export const EXTRACTIONFILE = API_URL + "extraction";
export const EXTRACTIONFILEDSN = API_URL + "extractionDsn";
export const SORTEDNOMENCLATUREGRADE = API_URL + "sortedNomenclatureGrade";
export const REASSOCIATIONCODESPAIES = API_URL + "reassociationCodePaie";

/* OTHERBASE CONTROLLER */
export const DBTOEXCEL = API_URL + "dbtoexcel";
export const UPLOADEXCEL = API_URL + "excelupload";
export const EXCELTODB = API_URL + "exceltodb";
export const DELETERETURNEXCEL = API_URL + "deleteReturnXls";
export const DELETEEXCELFILE = API_URL + "deleteExcelFile";
export const EXCELDISPLAYFILE = API_URL + "exceldisplayFile";
export const RELOOP_ASSOCIATION = API_URL + "reassociation";

/* EMAIL CONTROLLER */ 
export const SENDEMAIL = CONTROLLER_URL + "forgotten_password";

/* USER CONTROLLER */
export const CREATEDIRECTORY = API_URL + "createUser";
export const DELETEDIRECTORY = API_URL + "deleteUser";
export const FINDUSERBYEMAIL = API_URL + "findUserByEmail";

/* APIPLATFORM */
export const GRADECORRESP_API = API_URL + "grade_correspondances";
export const GRADENOMENC_API = API_URL + "nomenclature_grades";

export const CODEPAIECORRESP_API = API_URL + "code_paie_correspondances";
export const CODEPAIENOMENC_API = API_URL + "nomenclature_code_paies";

export const SERVICECORRESPONDANCE_API = API_URL + "service_correspondances";
export const SERVICENOMENC_API = API_URL + "nomenclature_services";
export const SERVICENOMENCPOLITIQUEPUBLIQUE_API = API_URL + "nomenclature_politique_publiques";

export const ECHELONCORRESPONDANCE_API = API_URL + "echelon_correspondances";
export const ECHELONNOMENC_API = API_URL + "nomenclature_echelons";

export const METIERCORRESPONDANCE_API = API_URL + "metier_correspondances";
export const METIERNOMENC_API = API_URL + "nomenclature_metiers";

export const LOGINCHECK_API = API_URL + "login_check";
export const CLIENTS_API = API_URL + "clients";
export const USERS_API = API_URL + 'users';
export const USERS_LOG_API = API_URL + 'user_logs';
export const EMPLOYEURS_API = API_URL + "employeurs";
export const AGENTS_API = API_URL + "agents";
export const AGENTSMOIS_API = API_URL + "agent_moiss";

export const NOMENCLATUREQUOTITE_API = API_URL + "nomenclature_quotites";
export const QUOTITECORRESPONDANCE_API = API_URL + "quotite_correspondances";
export const NOMENCLATUREPERMANENT_API = API_URL + "nomenclature_permanents";
export const PERMANENTCORRESPONDANCE_API = API_URL + "permanent_correspondances";

export const DISPLAYEFFECTIFXEMELIOS = API_URL + "effectifXemelios";
export const DELETEEFFECTIFXEMELIOS = API_URL + "deleteEffectifXemelios";
export const DISPLAYEFFECTIFDSN = API_URL + "effectifDsn";
export const DELETEEFFECTIFDSN = API_URL + "deleteEffectifDsn";

export const RETRAITEMENTBASEABSENCE = API_URL + "retraitementBaseAbsence";
export const DELETECODEPAIEDOUBLON = API_URL + "deleteCodePaieDoublon";

export const EXPORT_GRADE_XLS = API_URL + "exportXlsGrade";
export const EXPORT_SERVICE_XLS = API_URL + "exportXlsService";
export const EXPORT_METIER_XLS = API_URL + "exportXlsMetier";
export const EXPORT_CODE_PAIE_XLS = API_URL + "exportXlsCodePaie";
export const EXPORT_CORRESPONDANCE_XLS_DSN = API_URL + "exportCorrespondanceAgentXemeliosDsn";
export const EXPORT_PERMANENT_XLS = API_URL + "exportPermanentNonParametre";
export const EXPORT_QUOTITE_XLS = API_URL + "exportQuotiteNonParametree";

export const GET_DETAIL_PAR_MOIS = API_URL + "getDetailParMois";
export const EXPORT_DETAIL_PAR_MOIS = API_URL + "exportXlsDetailParMois";
export const GET_FICHE_DE_PAIE = API_URL + "getFicheDePaie";
export const EXPORT_FICHE_DE_PAIE = API_URL + "exportXlsFicheDePaie";
export const GET_MATRICULES = API_URL + "getMatricules";
export const GET_YEARS_BY_MATRICULE = API_URL + "getYearsByMatricule";
export const GET_MONTH_BY_YEAR_AND_MATRICULE = API_URL + "getMoisByYearAndMatricule";
export const EXPORT_BASE_AGENTS_XEMELIOS = API_URL + "exportXlsBaseAgentsXemelios";
export const GET_YEAR_DSN = API_URL + "getYearsDsn";
export const GET_MONTH_BY_YEAR_DSN = API_URL + "getMoisByYearDsn";
export const EXPORT_BASE_AGENTS_DSN = API_URL + "exportXlsBaseAgentsDsn";

/* PBI CONTROLLER */
export const PBI_REPORT = API_URL + "powerbi/report";
